import { capitalize } from 'es-toolkit/compat';
import type { GetPlacementTableRowData } from 'features/traffic/campaigns/campaign-configs/types';

import { filterMarketplaceCriteriaByFlavor } from '../../utils/filter-marketplace-criteria';
import { getFormattedTimeRange } from '../../utils/get-formatted-time-range';
import { getLanguageOptionFromFlavor } from '../../utils/get-language-options';

import type { FeaturedBrandsPlacementTableRowData } from '../types';

export const getPlacementTableRowData: GetPlacementTableRowData<FeaturedBrandsPlacementTableRowData> = ({
  flavor,
  platformValue,
  placementGroup,
  projectEvents,
}) => {
  const { eligibilityCriteria, id, name, placementGroupId } = placementGroup;
  const marketplaceCriteria = eligibilityCriteria.marketplaceCriteria;
  const relatedPlacementGroupMarketplaceCriteria = filterMarketplaceCriteriaByFlavor(marketplaceCriteria, flavor);

  const { timeRange, timeRangeDefault, keywords } = eligibilityCriteria ?? {};

  const languageOption = getLanguageOptionFromFlavor(flavor);

  const dateRangeValue = getFormattedTimeRange({
    languageOption,
    marketplaceCriteria: relatedPlacementGroupMarketplaceCriteria,
    projectEvents,
    timeRange,
    timeRangeDefault,
  });

  const placementElementId = `placement-group-${placementGroupId}`;
  const placementHeaders = capitalize(platformValue);
  const placementTableData = {
    dateRange: {
      label: 'Date range',
      value: dateRangeValue,
    },
    keywords: {
      label: 'Keywords',
      value: keywords,
    },
    name: {
      label: 'Name',
      value: name,
    },
  };

  return {
    id,
    name,
    placementElementId,
    placementHeaders,
    placementTableData,
  };
};
